const homeRouter = [
  {
    path:'',
    redirect:'syBanKuai'
  },
  {
    path:'syBanKuai',
    component: () => import('../views/home/children/syBanKuai'),
    meta:{
      title:'首页',
      needLogin:true
    }
  },
  {
    path:'mbzxBanKuai',
    component: () => import('../views/home/children/mbzxBanKuai'),
    children:[
      {
        path:'',
        redirect:'zyMuBan'
      },
      {
        path:'zyMuBan',
        component: () => import('../views/home/children/mbzxBanKuai/zyMuBan'),
        meta:{
          title:'自有模板',
          needLogin:true
        }
      },
      {
        path:'dyjyMuBan',
        component: () => import('../views/home/children/mbzxBanKuai/dyjyMuBan'),
        meta:{
          title:'系统模板',
          needLogin:true
        }
      }
    ]
  },
  {
    path:'zncgBanKuai',
    component:() => import('../views/home/children/zncgBanKuai'),
    meta:{
      title:'编辑内容',
      needLogin:true
    }
  },
  {
    path:'zxwzBanKuai',
    component:() => import('../views/home/children/zxwzBanKuai'),
    meta:{
      title:'最新文章',
      needLogin:true
    }
  },
  {
    path:'wdwzBanKuai',
    component:() => import('../views/home/children/wdwzBanKuai'),
    meta:{
      title:'导出文章',
      needLogin:true
    }
  },
  {
    path:'daochuBanKuai',
    component:() => import('../views/home/children/dcwzBanKuai/daochuBanKuai'),
    meta:{
      title:'导出文章',
      needLogin:true
    }
  },
  {
    path:'hszBanKuai',
    component:() => import('../views/home/children/hszBanKuai'),
    meta:{
      title:'回收站',
      needLogin:true
    }
  },
  {
    path:'xxzxBanKuai',
    component:() => import('../views/home/children/xxzxBanKuai'),
    meta:{
      title:'消息中心',
      needLogin:true
    }
  },
  {
    path:'xxzxDetailBanKuai',
    component:() => import('../views/home/children/xxzxDetailBanKuai'),
    meta:{
      title:'消息详情',
      needLogin:true
    }
  },
  {
    path:'zhszBanKuai',
    component:() => import('../views/home/children/zhszBanKuai'),
    children:[
      {
        path:'',
        redirect:'jbxxBanKuai'
      },
      {
        path: 'jbxxBanKuai',
        component: () => import('../views/home/children/zhszBanKuai/jbxxBanKuai'),
        meta:{
          title:'基本信息',
          needLogin:true
        }
      },
      {
        path:'zhaqBanKuai',
        component: () => import('../views/home/children/zhszBanKuai/zhaqBanKuai'),
        meta: {
          title: '账号安全',
          needLogin: true
        }
      }
    ]
  }

]

export default  homeRouter
